import {Type} from 'class-transformer';
import {IsInt, IsNumber, ValidateNested} from 'class-validator';

export class ProductFeatureFeedbackPreferredContactTimeRangeDto {
  @IsInt()
  from!: number;

  @IsInt()
  to!: number;
}

export class ProductFeatureFeedbackStep2Dto {
  @IsInt()
  feedbackId!: number;

  @IsNumber()
  contactMobile!: number;

  @IsInt()
  preferredContactDate!: number;

  @ValidateNested()
  @Type(() => ProductFeatureFeedbackPreferredContactTimeRangeDto)
  preferredContactTimeRange!: ProductFeatureFeedbackPreferredContactTimeRangeDto;
}
